<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>编辑设备</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="equipmentForm" ref="equipmentForm" :rules="addEquipmentRules">
            <el-form-item label="设备序列号" label-width="150px" prop="deviceId">
                <el-input v-model="equipmentForm.deviceId"></el-input>
            </el-form-item>
            <el-form-item label="条形码编号" label-width="150px" prop="productIdentity">
                <el-input v-model="equipmentForm.productIdentity"></el-input>
            </el-form-item>
            <el-form-item label="所在仓库" label-width="150px" prop="storageId">
                <el-select v-model="equipmentForm.storageId" placeholder="仓库">
                    <el-option v-for="item in storageArr" :key="item.id" :label="item.storageName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="添加字段" label-width="150px">
                <el-col :span="2">
                    <el-button type="warning" @click.prevent="addProperty">增加</el-button>
                </el-col>
                <el-col :span="1">key:</el-col>
                <el-col :span="4">
                    <el-input v-model="key"></el-input>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">value:</el-col>
                <el-col :span="4">
                    <el-input v-model="value"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="已加字段" label-width="150px" v-if="property.length">
                <div v-for="(item,index) in property" :key="index" class="mt10">
                    {{++index}}、{{item.name}} - {{item.value}}
                    <el-button type="danger" @click.prevent="removeProperty(index)">删除</el-button>
                </div>
            </el-form-item>
            <el-form-item label="备注信息" label-width="150px">
                <el-input type="textarea" v-model="equipmentForm.remark"></el-input>
            </el-form-item>
    
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">更新</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {
        getProducts,
        getStorages,
        postProducts,
        getProductsIds,
        patchProductsIds
    } from '../../api/version'
    
    export default {
        data() {
            return {
                fetchList: [],
                equipmentForm: {
                    storageId: '',
                    deviceId: '',
                    productIdentity: '',
                    otherProperty: {}
                },
                addEquipmentRules: {
                    deviceId: [{
                        required: true,
                        message: '请填写设备序列号',
                        trigger: 'blur'
                    }],
                    productIdentity: [{
                        required: true,
                        message: '请填写条形码编号',
                        trigger: 'blur'
                    }],
                    storageId: [{
                        type: 'number',
                        required: true,
                        message: '请选择所在仓库',
                        trigger: 'blur'
                    }],
    
                },
                property: [
    
                ],
                storageArr: [],
                key: '',
                value: ''
            }
        },
    
        created() {
            getStorages(sessionStorage.userId).then(res => {
                this.storageArr = res.data
            })
            getProductsIds(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res.data)
                this.equipmentForm = res.data
                if(res.data.otherProperty) {
                    for(var i in res.data.otherProperty) {
                        this.property.push({
                            name: i,
                            value: res.data.otherProperty[i]
                        })
                    }
                }
            })
        },
    
        methods: {
            goBack() {
                this.$router.push('/optinalList')
            },
            onSubmit() {
                this.$refs['equipmentForm'].validate((valid) => {
                    if (valid) {
                        this.equipmentForm.otherProperty = {}
                        this.property.forEach(res => {
                            this.equipmentForm.otherProperty[res.name] = res.value
                        })
                        patchProductsIds(sessionStorage.userId, this.equipmentForm.productId, this.equipmentForm).then(res => {
                            console.log(res)
                            if (res.data) {
                                this.$message({
                                    message: '恭喜你，更新成功',
                                    type: 'success'
                                });
                                this.$router.push('/optinalList')
                            }
                        }, err => {
                            this.$message.error('更新失败')
                        })
                    }
                })
            },
            addProperty() {
                if(this.key && this.value) {
                        this.property.push({
                        name: this.key,
                        value: this.value
                    })
                    this.key = ''
                    this.value = ''
                }
                
            },
            removeProperty(index) {
                console.log(index)
                this.property.splice(--index, 1)
            }
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .mt10 {
        margin-top: 10px;
    }
    
    .mt10:first-child {
        margin-top: 0;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// EditEquipmentX.vue?6a401b18